import axios from '@axios'

// Carga en segundo plano las fotos de un listado de materiales pedido con
// GET /materiales?sinImg=1. Solo pide las de materiales con imagen (tieneImg),
// por lotes y varios a la vez, para que la tabla se pinte al instante.
//
// Por defecto pide miniaturas (thumb=1) y las deja en `m.thumb`; la imagen
// original (`m.img`) solo se pide cuando hace falta (editar / ver detalle).
//
// Los objetos deben tener ya las claves `img` y `thumb` (aunque sea '') para
// que Vue 2 las trate como reactivas; `prepararSinImagen` se encarga de eso.
export function prepararSinImagen(lista) {
  (lista || []).forEach(m => {
    if (m.img === undefined) m.img = ''
    if (m.thumb === undefined) m.thumb = ''
    m.tieneImg = !!Number(m.tieneImg)
  })
  return lista
}

export async function cargarImagenesMateriales(lista, opciones = {}) {
  const thumb = opciones.thumb !== false
  const campo = thumb ? 'thumb' : 'img'
  const tamLote = opciones.tamLote || 20
  const paralelo = opciones.paralelo || 4

  // Se respeta el orden de la lista (prioridad a lo que se ve primero)
  const porId = {}
  const ids = []
  ;(lista || []).forEach(m => {
    if (m.tieneImg && !m[campo] && !m._pidiendoImg) {
      m._pidiendoImg = true
      porId[m.id] = m
      ids.push(m.id)
    }
  })
  const lotes = []
  for (let i = 0; i < ids.length; i += tamLote) lotes.push(ids.slice(i, i + tamLote))

  const trabajador = async () => {
    while (lotes.length) {
      const lote = lotes.shift()
      let ok = false
      try {
        const { data } = await axios.get('/materiales/imagenes', {
          params: { ids: lote.join(','), thumb: thumb ? 1 : 0 },
          silencioso: true,
        })
        ;(data || []).forEach(d => {
          const m = porId[d.id]
          if (m && d.img) m[campo] = d.img
        })
        ok = true
      } catch (e) {
        // Si falla un lote seguimos con el siguiente: la tabla ya es usable sin fotos.
        console.error('Error cargando imagenes de materiales:', e)
      }
      lote.forEach(id => {
        const m = porId[id]
        m._pidiendoImg = false
        // Si el servidor no la devolvio es que no hay foto valida: que no salga nada
        if (ok && !m[campo]) m.tieneImg = false
      })
    }
  }

  await Promise.all(Array.from({ length: Math.min(paralelo, lotes.length) }, trabajador))
}
